export default "__VITE_ASSET__DCQ14Dqm__"